import {SystemColumnName} from 'data-frames/DataFrameConstants';
import {DataFrameColumnDef, HydratedProperties} from 'data-frames/DataFrameTypes';
import {DataFrameTableMode} from 'data-frames/table/DataFrameTableConstants';
import resolveDataFrameValue, {
  DataFrameResolutionConfig,
  DataFrameValueResolutionMode,
} from 'data-frames/util/resolveDataFrameValue';
import jsonValueToReadable from 'util/jsonValueToReadable';
import {JSONValue} from 'util/Types';

const TABLE_MODE_TO_RESOLUTION_CONFIG: {[key in DataFrameTableMode]: DataFrameResolutionConfig} = {
  [DataFrameTableMode.RICH]: {
    apiIdentifiedObjects: DataFrameValueResolutionMode.NAME,
    blobs: DataFrameValueResolutionMode.NONE,
  },
  [DataFrameTableMode.TEXT]: {
    apiIdentifiedObjects: DataFrameValueResolutionMode.NONE,
    blobs: DataFrameValueResolutionMode.NONE,
  },
  [DataFrameTableMode.RAW_WAREHOUSE]: {
    apiIdentifiedObjects: DataFrameValueResolutionMode.NONE,
    blobs: DataFrameValueResolutionMode.WAREHOUSE_BLOB_DICT,
  },
};

function isExcludedValueToUserFacingString(isExcludedValue: boolean): string {
  return isExcludedValue ? 'Yes' : 'No';
}

export default function cellValueToUserFacingString(
  cellValue: JSONValue,
  column: DataFrameColumnDef,
  hydratedProperties: HydratedProperties,
  tableMode: DataFrameTableMode
): string {
  return jsonValueToReadable(
    column.systemName === SystemColumnName.IS_EXCLUDED
      ? isExcludedValueToUserFacingString(cellValue as boolean)
      : resolveDataFrameValue(cellValue, hydratedProperties, TABLE_MODE_TO_RESOLUTION_CONFIG[tableMode])
  );
}
